import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { getOptimizelyFeatureFlagVariation, isAllowedToTriggerExperiment } from 'lib/optimizely/optimizelyUtils'

/** Customer overlapping same-property extra-room lead names. Agent Hub keeps the legacy form. */
export default function isOverlappingRoomGuestNamesEnabled(state: App.State): boolean {
  const flagId = OptimizelyFeatureFlags.croCollectOverlappingRoomGuestNames
  return isAllowedToTriggerExperiment(true, state.utm.content, flagId) && getOptimizelyFeatureFlagVariation(state, flagId)
}
